<template>
  <div>
    <h2>Login</h2>
    <form>
      <text-input
        :auto-focus="true"
        :value="email"
        placeholder="johnsmith@example.com"
        label="Email address"
        name="email"
        type="email"
        :error="!isValidEmail"
        validation-message="A valid email is required"
        @input="email = $event"
        @enter="login"
      />
      <text-input
        :value="password"
        placeholder="Your strong password"
        label="Password"
        name="password"
        type="password"
        :error="!password"
        validation-message="Your passwords can't be empty"
        @input="password = $event"
        @enter="login"
      />
      <small class="mt-2 forgot-password">
        <router-link :to="{ name: 'password-reset-request' }">
          Forgot my password
        </router-link>
      </small>
      <div class="flex flex-column justify-content-start align-items-center">
        <loading-button
          :disabled="!isValidEmail || !password"
          :loading="loading"
          @click="login"
        >
          Login
        </loading-button>
        <or-divider />
        <router-link
          class="btn btn-secondary mt-0"
          :to="{
            name: 'login-saml',
            query: { redirectUrl: $route.query.redirectUrl },
          }"
        >
          Sign in with SSO
        </router-link>

        <p class="text-center i-mt-10">
          <a href="https://www.inscribe.ai/demo-request"
            >Don't have an account? Contact sales.</a
          >
        </p>
      </div>
    </form>
  </div>
</template>

<script>
import { LoadingButton, OrDivider, TextInput } from '@inscribe/ui-kit';
import { isValidEmail } from '@/utils/validation';
import { showNotification } from '@/utils/notifications';

export default {
  components: {
    'loading-button': LoadingButton,
    'or-divider': OrDivider,
    'text-input': TextInput,
  },
  data() {
    return {
      email: '',
      loading: false,
      password: '',
    };
  },
  computed: {
    isValidEmail() {
      return isValidEmail(this.email);
    },
  },
  methods: {
    login(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (this.isValidEmail && this.password) {
        const data = new FormData();
        const { organisation_id } = this.$route.query;
        data.append('email', this.email);
        data.append('password', this.password);
        if (organisation_id) {
          data.append('organisation_id', organisation_id);
        }
        this.loading = true;
        this.$store
          .dispatch('login', data)
          .then((response) => {
            this.loading = false;
            const { auth_required: authRequired, two_fa_type: twoFaType } =
              response.data.user;
            if (authRequired === '2fa') {
              this.$router.push({
                name: 'await-2fa',
                query: {
                  type: twoFaType,
                  ...this.$route.query,
                },
                params: this.$route.params,
              });
            } else {
              const { redirectUrl } = this.$route.query;
              document.location = `https://${
                document.location.host
              }${document.location.pathname.replace(/^\//, '')}/${
                redirectUrl ? decodeURI(redirectUrl) : '#/customers'
              }`;
              document.location.reload();
            }
          })
          .catch((error) => {
            this.loading = false;
            showNotification({
              type: 'error',
              title: 'Error logging in',
              message:
                error.response?.data?.message ||
                'Something went wrong, please try again',
            });
          });
      }
    },
  },
};
</script>

<style scoped>
.forgot-password {
  display: block;
  margin-bottom: 16px;
  margin-top: -8px;
}
</style>
